/* AUTO-GENERATED — do not edit */

import Ai from '@assets/icons/AI.svg';
import AlarmClock from '@assets/icons/AlarmClock.svg';
import AlertBetWon from '@assets/icons/AlertBetWon.svg';
import AlertDeposit from '@assets/icons/AlertDeposit.svg';
import AlertLogin from '@assets/icons/AlertLogin.svg';
import AlertLoginMethod from '@assets/icons/AlertLoginMethod.svg';
import AlertPassword from '@assets/icons/AlertPassword.svg';
import AlertPriceAlert from '@assets/icons/AlertPriceAlert.svg';
import AlertRewardsHub from '@assets/icons/AlertRewardsHub.svg';
import AlertTwoFa from '@assets/icons/AlertTwoFa.svg';
import AlertWithdraw from '@assets/icons/AlertWithdraw.svg';
import ArrowDown from '@assets/icons/ArrowDown.svg';
import ArrowRight from '@assets/icons/ArrowRight.svg';
import ArrowSmall from '@assets/icons/ArrowSmall.svg';
import ArrowSmallDown from '@assets/icons/ArrowSmallDown.svg';
import ArrowSmallDown2 from '@assets/icons/ArrowSmallDown2.svg';
import ArrowSmallLeft from '@assets/icons/ArrowSmallLeft.svg';
import ArrowSmallRight from '@assets/icons/ArrowSmallRight.svg';
import ArrowSmallUp from '@assets/icons/ArrowSmallUp.svg';
import ArrowUp from '@assets/icons/ArrowUp.svg';
import ArrowUp2 from '@assets/icons/ArrowUp2.svg';
import Attention from '@assets/icons/Attention.svg';
import AttentionTriangle from '@assets/icons/AttentionTriangle.svg';
import BalanceConvert from '@assets/icons/BalanceConvert.svg';
import BalanceDeposit from '@assets/icons/BalanceDeposit.svg';
import Bookmark from '@assets/icons/Bookmark.svg';
import BookmarkFilled from '@assets/icons/BookmarkFilled.svg';
import Broom from '@assets/icons/Broom.svg';
import Burger2 from '@assets/icons/Burger2.svg';
import Calculator from '@assets/icons/Calculator.svg';
import Calendar from '@assets/icons/Calendar.svg';
import Cancel from '@assets/icons/Cancel.svg';
import CaretDown from '@assets/icons/CaretDown.svg';
import Category2 from '@assets/icons/Category2.svg';
import CategoryAccount from '@assets/icons/CategoryAccount.svg';
import CategoryAll from '@assets/icons/CategoryAll.svg';
import CategoryComments from '@assets/icons/CategoryComments.svg';
import CategoryFunds from '@assets/icons/CategoryFunds.svg';
import CategoryMarkets from '@assets/icons/CategoryMarkets.svg';
import Chat from '@assets/icons/Chat.svg';
import Check from '@assets/icons/Check.svg';
import CheckCircle from '@assets/icons/CheckCircle.svg';
import CheckThin from '@assets/icons/CheckThin.svg';
import ChevronDown from '@assets/icons/ChevronDown.svg';
import ChevronDownRounded from '@assets/icons/ChevronDownRounded.svg';
import ChevronRight from '@assets/icons/ChevronRight.svg';
import ChevronUp from '@assets/icons/ChevronUp.svg';
import Clean from '@assets/icons/Clean.svg';
import Clock from '@assets/icons/Clock.svg';
import Close from '@assets/icons/Close.svg';
import CloseCircle from '@assets/icons/CloseCircle.svg';
import CloseFilled from '@assets/icons/CloseFilled.svg';
import CloudLock from '@assets/icons/CloudLock.svg';
import Coins from '@assets/icons/Coins.svg';
import Commodity from '@assets/icons/Commodity.svg';
import Copy from '@assets/icons/Copy.svg';
import Copy2 from '@assets/icons/Copy2.svg';
import Copy3 from '@assets/icons/Copy3.svg';
import CopyInverted from '@assets/icons/CopyInverted.svg';
import CopyLink from '@assets/icons/CopyLink.svg';
import CreditCard from '@assets/icons/CreditCard.svg';
import DataPoint from '@assets/icons/DataPoint.svg';
import Deal from '@assets/icons/Deal.svg';
import Deal2 from '@assets/icons/Deal2.svg';
import Deposit from '@assets/icons/Deposit.svg';
import Document from '@assets/icons/Document.svg';
import Download from '@assets/icons/Download.svg';
import Edit from '@assets/icons/Edit.svg';
import EditLine from '@assets/icons/EditLine.svg';
import EditLineSmall from '@assets/icons/EditLineSmall.svg';
import EditorPicks from '@assets/icons/EditorPicks.svg';
import EllipsisVertical from '@assets/icons/EllipsisVertical.svg';
import EmojiSad from '@assets/icons/EmojiSad.svg';
import EmojiSadSweat from '@assets/icons/EmojiSadSweat.svg';
import EmojiSmile from '@assets/icons/EmojiSmile.svg';
import EmojiTearsOfJoy from '@assets/icons/EmojiTearsOfJoy.svg';
import EmojiThumbsDown from '@assets/icons/EmojiThumbsDown.svg';
import EmojiThumbsUp from '@assets/icons/EmojiThumbsUp.svg';
import EmojiWeary from '@assets/icons/EmojiWeary.svg';
import Etf from '@assets/icons/Etf.svg';
import ExternalLink from '@assets/icons/ExternalLink.svg';
import Eye from '@assets/icons/Eye.svg';
import EyeOff from '@assets/icons/EyeOff.svg';
import Facebook from '@assets/icons/Facebook.svg';
import Filter from '@assets/icons/Filter.svg';
import Fire from '@assets/icons/Fire.svg';
import FormatHorizontal from '@assets/icons/FormatHorizontal.svg';
import FormatSquare from '@assets/icons/FormatSquare.svg';
import FormatVertical from '@assets/icons/FormatVertical.svg';
import Freeze from '@assets/icons/Freeze.svg';
import Fullscreen from '@assets/icons/Fullscreen.svg';
import Global from '@assets/icons/Global.svg';
import GoDown from '@assets/icons/GoDown.svg';
import Google from '@assets/icons/Google.svg';
import Google2 from '@assets/icons/Google2.svg';
import GooglePlay from '@assets/icons/GooglePlay.svg';
import GoUp from '@assets/icons/GoUp.svg';
import Grip from '@assets/icons/Grip.svg';
import Grow from '@assets/icons/Grow.svg';
import HeaderWallet from '@assets/icons/HeaderWallet.svg';
import HeartFilled from '@assets/icons/HeartFilled.svg';
import HeartOutline from '@assets/icons/HeartOutline.svg';
import Hexagon from '@assets/icons/Hexagon.svg';
import IconMinus from '@assets/icons/IconMinus.svg';
import IconPlus from '@assets/icons/IconPlus.svg';
import Info from '@assets/icons/Info.svg';
import InfoBold from '@assets/icons/InfoBold.svg';
import Insight from '@assets/icons/Insight.svg';
import Key2 from '@assets/icons/Key2.svg';
import KycCar from '@assets/icons/KycCar.svg';
import KycCircleDollar from '@assets/icons/KycCircleDollar.svg';
import KycEyeOff from '@assets/icons/KycEyeOff.svg';
import KycFaceFrame from '@assets/icons/KycFaceFrame.svg';
import KycFacePerson from '@assets/icons/KycFacePerson.svg';
import KycHelp from '@assets/icons/KycHelp.svg';
import KycIdCard from '@assets/icons/KycIdCard.svg';
import KycIdCardSmall from '@assets/icons/KycIdCardSmall.svg';
import KycPassport from '@assets/icons/KycPassport.svg';
import KycSafe from '@assets/icons/KycSafe.svg';
import Lightning from '@assets/icons/Lightning.svg';
import Like from '@assets/icons/Like.svg';
import Link from '@assets/icons/Link.svg';
import Link2 from '@assets/icons/Link2.svg';
import LinkAcc from '@assets/icons/LinkAcc.svg';
import LinkedIn from '@assets/icons/LinkedIn.svg';
import Locked from '@assets/icons/Locked.svg';
import Locked2 from '@assets/icons/Locked2.svg';
import Logout2 from '@assets/icons/Logout2.svg';
import Max from '@assets/icons/Max.svg';
import MenuLines from '@assets/icons/MenuLines.svg';
import Minus from '@assets/icons/Minus.svg';
import Minus2 from '@assets/icons/Minus2.svg';
import Mobile from '@assets/icons/Mobile.svg';
import Monitor from '@assets/icons/Monitor.svg';
import NavCoin from '@assets/icons/NavCoin.svg';
import NavFlash from '@assets/icons/NavFlash.svg';
import NavTasks from '@assets/icons/NavTasks.svg';
import NavUsdc from '@assets/icons/NavUsdc.svg';
import NavUsdt from '@assets/icons/NavUsdt.svg';
import News2 from '@assets/icons/News2.svg';
import NewsFire from '@assets/icons/NewsFire.svg';
import NewsIcon from '@assets/icons/NewsIcon.svg';
import NewsLike from '@assets/icons/NewsLike.svg';
import NewsList from '@assets/icons/NewsList.svg';
import NewsMessage from '@assets/icons/NewsMessage.svg';
import Newspaper from '@assets/icons/Newspaper.svg';
import NewsPrediction from '@assets/icons/NewsPrediction.svg';
import NewsReward from '@assets/icons/NewsReward.svg';
import NewsTwitter from '@assets/icons/NewsTwitter.svg';
import NewsWorld from '@assets/icons/NewsWorld.svg';
import Notification from '@assets/icons/Notification.svg';
import Notify2 from '@assets/icons/Notify2.svg';
import NotifyAdd from '@assets/icons/NotifyAdd.svg';
import NotifyAdd2 from '@assets/icons/NotifyAdd2.svg';
import OrderbookAll from '@assets/icons/OrderbookAll.svg';
import OrderHoriz from '@assets/icons/OrderHoriz.svg';
import PassLock2 from '@assets/icons/PassLock2.svg';
import People from '@assets/icons/People.svg';
import Pin from '@assets/icons/Pin.svg';
import Plus from '@assets/icons/Plus.svg';
import Plus2 from '@assets/icons/Plus2.svg';
import PriceFlag from '@assets/icons/PriceFlag.svg';
import ProfileTick from '@assets/icons/ProfileTick.svg';
import Pulse from '@assets/icons/Pulse.svg';
import QrCode from '@assets/icons/QrCode.svg';
import QrRefresh from '@assets/icons/QrRefresh.svg';
import Referrals from '@assets/icons/Referrals.svg';
import Reset from '@assets/icons/Reset.svg';
import ResizeCorner from '@assets/icons/ResizeCorner.svg';
import Science from '@assets/icons/Science.svg';
import Search from '@assets/icons/Search.svg';
import Settings from '@assets/icons/Settings.svg';
import Settings2 from '@assets/icons/Settings2.svg';
import Share from '@assets/icons/Share.svg';
import Share2 from '@assets/icons/Share2.svg';
import Sliders from '@assets/icons/Sliders.svg';
import SliderVertical from '@assets/icons/SliderVertical.svg';
import SocialMedia from '@assets/icons/SocialMedia.svg';
import Sport from '@assets/icons/Sport.svg';
import StarFilled from '@assets/icons/StarFilled.svg';
import Stock from '@assets/icons/Stock.svg';
import Swap from '@assets/icons/Swap.svg';
import Swap2 from '@assets/icons/Swap2.svg';
import SwapVertical from '@assets/icons/SwapVertical.svg';
import Tablet from '@assets/icons/Tablet.svg';
import Task from '@assets/icons/Task.svg';
import Telegram from '@assets/icons/Telegram.svg';
import Telegram2 from '@assets/icons/Telegram2.svg';
import ThemeMoon from '@assets/icons/ThemeMoon.svg';
import ThemeSun from '@assets/icons/ThemeSun.svg';
import Ticket from '@assets/icons/Ticket.svg';
import Transaction from '@assets/icons/Transaction.svg';
import Trash from '@assets/icons/Trash.svg';
import Trash2 from '@assets/icons/Trash2.svg';
import Twitter from '@assets/icons/Twitter.svg';
import Unlink from '@assets/icons/unlink.svg';
import Unlock2 from '@assets/icons/Unlock2.svg';
import UserCircle from '@assets/icons/UserCircle.svg';
import Users2 from '@assets/icons/Users2.svg';
import UsersGroup from '@assets/icons/UsersGroup.svg';
import UserSingle from '@assets/icons/UserSingle.svg';
import VolumeDown from '@assets/icons/VolumeDown.svg';
import VolumeUp from '@assets/icons/VolumeUp.svg';
import Wallet from '@assets/icons/Wallet.svg';
import WalletOutline from '@assets/icons/WalletOutline.svg';
import Warning from '@assets/icons/Warning.svg';
import Watch from '@assets/icons/Watch.svg';
import Whale from '@assets/icons/Whale.svg';
import WhatsApp from '@assets/icons/WhatsApp.svg';
import XLogo from '@assets/icons/XLogo.svg';
import Youtube from '@assets/icons/Youtube.svg';
import React from 'react';
import { cn } from '@/lib/ui-kit/utils';

export const Icons = {
  Ai,
  AlarmClock,
  AlertBetWon,
  AlertDeposit,
  AlertLogin,
  AlertLoginMethod,
  AlertPassword,
  AlertPriceAlert,
  AlertRewardsHub,
  AlertTwoFa,
  AlertWithdraw,
  ArrowDown,
  ArrowRight,
  ArrowSmall,
  ArrowSmallDown,
  ArrowSmallDown2,
  ArrowSmallLeft,
  ArrowSmallRight,
  ArrowSmallUp,
  ArrowUp,
  ArrowUp2,
  Attention,
  AttentionTriangle,
  BalanceConvert,
  BalanceDeposit,
  Bookmark,
  BookmarkFilled,
  Broom,
  Burger2,
  Calculator,
  Calendar,
  Cancel,
  CaretDown,
  Category2,
  CategoryAccount,
  CategoryAll,
  CategoryComments,
  CategoryFunds,
  CategoryMarkets,
  Chat,
  Check,
  CheckCircle,
  CheckThin,
  ChevronDown,
  ChevronDownRounded,
  ChevronRight,
  ChevronUp,
  Clean,
  Clock,
  Close,
  CloseCircle,
  CloseFilled,
  CloudLock,
  Coins,
  Commodity,
  Copy,
  Copy2,
  Copy3,
  CopyInverted,
  CopyLink,
  CreditCard,
  DataPoint,
  Deal,
  Deal2,
  Deposit,
  Document,
  Download,
  Edit,
  EditLine,
  EditLineSmall,
  EditorPicks,
  EllipsisVertical,
  EmojiSad,
  EmojiSadSweat,
  EmojiSmile,
  EmojiTearsOfJoy,
  EmojiThumbsDown,
  EmojiThumbsUp,
  EmojiWeary,
  Etf,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  Filter,
  Fire,
  FormatHorizontal,
  FormatSquare,
  FormatVertical,
  Freeze,
  Fullscreen,
  Global,
  GoDown,
  Google,
  Google2,
  GooglePlay,
  GoUp,
  Grip,
  Grow,
  HeaderWallet,
  HeartFilled,
  HeartOutline,
  Hexagon,
  IconMinus,
  IconPlus,
  Info,
  InfoBold,
  Insight,
  Key2,
  KycCar,
  KycCircleDollar,
  KycEyeOff,
  KycFaceFrame,
  KycFacePerson,
  KycHelp,
  KycIdCard,
  KycIdCardSmall,
  KycPassport,
  KycSafe,
  Lightning,
  Like,
  Link,
  Link2,
  LinkAcc,
  LinkedIn,
  Locked,
  Locked2,
  Logout2,
  Max,
  MenuLines,
  Minus,
  Minus2,
  Mobile,
  Monitor,
  NavCoin,
  NavFlash,
  NavTasks,
  NavUsdc,
  NavUsdt,
  News2,
  NewsFire,
  NewsIcon,
  NewsLike,
  NewsList,
  NewsMessage,
  Newspaper,
  NewsPrediction,
  NewsReward,
  NewsTwitter,
  NewsWorld,
  Notification,
  Notify2,
  NotifyAdd,
  NotifyAdd2,
  OrderbookAll,
  OrderHoriz,
  PassLock2,
  People,
  Pin,
  Plus,
  Plus2,
  PriceFlag,
  ProfileTick,
  Pulse,
  QrCode,
  QrRefresh,
  Referrals,
  Reset,
  ResizeCorner,
  Science,
  Search,
  Settings,
  Settings2,
  Share,
  Share2,
  Sliders,
  SliderVertical,
  SocialMedia,
  Sport,
  StarFilled,
  Stock,
  Swap,
  Swap2,
  SwapVertical,
  Tablet,
  Task,
  Telegram,
  Telegram2,
  ThemeMoon,
  ThemeSun,
  Ticket,
  Transaction,
  Trash,
  Trash2,
  Twitter,
  Unlink,
  Unlock2,
  UserCircle,
  Users2,
  UsersGroup,
  UserSingle,
  VolumeDown,
  VolumeUp,
  Wallet,
  WalletOutline,
  Warning,
  Watch,
  Whale,
  WhatsApp,
  XLogo,
  Youtube,
} as const;

export type IconName = keyof typeof Icons;

export interface IconProps extends Omit<React.SVGProps<SVGSVGElement>, 'ref'> {
  name: IconName;
  size?: number | string;
  className?: string;
}

export const Icon = ({ name, size = '1em', className = '', ...rest }: IconProps) => {
  const SVG = Icons[name];
  return (
    <SVG
      width={size}
      height={size}
      className={cn('inline-block flex-shrink-0', className)}
      {...rest}
    />
  );
};
